import { Badge, Box, Button, Pagination, Stack, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import styled from "styled-components";

export const FormattedAddress = (address: any) => {
    return `${address && address.substring(0, 10)}...`;
};

export const ImagesSmall = styled('img')({
    width: "16px",
    height: "auto",
    '@media (max-width: 600px)': {
        width: "12px",
    }
});

export const Images = styled('img')({
    width: "24px",
    height: "auto"
});

export const ImagesLarge = styled('img')({
    width: "160px",
    height: "auto",
    filter: "drop-shadow(40px 40px 5rem #959595)",
    '@media (max-width: 600px)': {
        width: "128px",
    }
});

export const ImagesSuperLarge = styled('img')({
    width: "250px",
    height: "auto",
    filter: "drop-shadow(40px 40px 5rem #959595)",
    '@media (max-width: 600px)': {
        width: "128px",
    }
});


export const BasicBadge = styled(Badge)({
    "& .MuiBadge-badge": {
        color: "white !important",
        padding: "unset",
        backgroundColor: "black",
        right: "50%"
    },
});

export const CardSelected = styled(Stack)({
    gap: "32px",
    padding: "32px 24px 24px",
    alignItems: "center",
    background: "linear-gradient(to bottom, #FFFFFF 31%, #F3F3F3 100%)",
    border: "1.5px solid var(--black)",
    borderRadius: "42px",
    boxShadow: "35px 56px 88px 0px rgba(0, 0, 0, 0.15)",
    '@media (max-width: 960px)': {
        gap: "24px",
    },
    '@media (max-width: 600px)': {
        padding: "32px 12px 24px",
        gap: "16px",
    }
});

export const ContainButtonChangeContract = styled(Button)({
    borderRadius: "28px !important",
    width: "250px !important",
    color: "white !important",
    padding: "4px 24px !important",
    backgroundColor: "#151514 !important",
    fontSize: "16px !important",
    fontWeight: "500 !important",
    textTransform: 'none',

    "&:hover": {
        backgroundColor: "#151514",
        opacity: 0.9
    }
});

export const ContainButton = styled(Button)({
    borderRadius: "28px !important",
    width: "200px !important",
    color: "white !important",
    padding: "4px 24px !important",
    backgroundColor: "#151514 !important",
    fontSize: "16px !important",
    fontWeight: "500 !important",
    textTransform: 'none',

    "&:hover": {
        backgroundColor: "#151514",
        opacity: 0.9
    }
});

export const OutlineButtonChangeContract = styled(Button)({
    borderRadius: "28px !important",
    width: "250px !important",
    padding: "4px 24px !important",
    border: "1px solid var(--secondary) !important",
    color: "var(--secondary) !important",
    fontSize: "16px !important",
    fontWeight: "500 !important",
});

export const OutlineButton = styled(Button)({
    borderRadius: "28px !important",
    width: "200px !important",
    padding: "4px 24px !important",
    border: "1px solid var(--secondary) !important",
    color: "var(--secondary) !important",
    fontSize: "16px !important",
    fontWeight: "500 !important",
});

export const ContainButtonShort = styled(Button)({
    borderRadius: "28px !important",
    width: "160px !important",
    color: "white !important",
    padding: "4px 24px !important",
    backgroundColor: "#151514 !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  

    "&:hover": {
        backgroundColor: "#151514",
        opacity: 0.9
    },
    "&:disabled": {
        backgroundColor: "#808080 !important",
        color: "darkgray !important"
    }
});

export const OutlineButtonShort = styled(Button)({
    borderRadius: "28px !important",
    width: "120px !important",
    padding: "4px 24px !important",
    border: "1px solid var(--black) !important",
    color: "var(--black) !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
});

export const LinearText = styled(Typography)({
    fontSize: "38px !important",
    fontWeight: "700 !important",
    marginLeft: "8px !important",
    background: "-webkit-linear-gradient(#52E01A, #20AD4E)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",

    '@media (max-width: 600px)': {
        fontSize: "24px !important",
    }
});

export const LinearTextDialog = styled(Typography)({
    fontSize: "24px !important",
    fontWeight: "700 !important",
    background: "-webkit-linear-gradient(#52E01A, #20AD4E)",
    "-webkit-background-clip": "text",
    "-webkit-text-fill-color": "transparent",
});

export const AccountBotton = styled(Button)({
    backgroundImage: 'linear-gradient(to bottom, #EEFFED 100%, #EDEDED 100%) !important',
    backgroundColor: "unset !important",
    borderRadius: '28px !important',
    padding: '6px 12px !important',
    color: 'var(--black) !important',
    border: '3px solid var(--white)!important',
    filter: "drop-shadow(0 4px 14.5px #3C434909)",
    fontSize: '14px !important',
    fontWeight: 500,
    gap: "8px",
    boxShadow: '0px 0px 3px -3px rgba(0,0,0,0.2),0px 0px 8px 1px rgba(0,0,0,0.14),0px 0px 8px 2px rgba(0,0,0,0.12)'
});

export const BoxTextAmount = styled(Box)({
    backgroundImage: "linear-gradient(to left, #52E01A 0%, #20AD4E 100%)",
    padding: "6px 48px 6px 24px",
    borderRadius: "25px",
    color: "var(--black)",
    fontWeight: 600,
    position: 'relative',
    zIndex: 1,
});

export const BoxValueAmount = styled(Box)({
    border: '0.5px solid #000',
    padding: "6px 52px",
    borderRadius: "25px",
    background: "#fff",
    opacity: '0.9',
    color: '#000',
    fontWeight: 500,
    position: 'relative',
    display: 'inline-block',
    marginLeft: '-38px',
    zIndex: 2,
});

export const TextAmount = styled(TextField)({
    border: '0.5px solid #000',
    padding: "6px 52px",
    borderRadius: "25px",
    background: "#fff",
    opacity: '0.9',
    color: '#000',
    fontWeight: 500,
    position: 'relative',
    display: 'inline-block',
    marginLeft: '-38px',
    zIndex: 2,
});

export const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const CustomTableHead = styled(TableHead)({
    backgroundImage: 'linear-gradient(to bottom, #EEFFED 100%, #EDEDED 100%) !important',
    backgroundColor: "unset !important",
});

export const CustomTableCellHead = styled(TableCell)({
    backgroundImage: 'linear-gradient(to left, #52E01A 0%, #20AD4E 100%)',
    backgroundColor: 'unset !important',
    borderRadius: '25px !important',
    padding: '8px 12px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    justifyContent: 'center',
    fontWeight: '600 !important',
    fontSize: '14px !important'
});

export const CustomTableCellHeadIcon = styled(TableCell)({
    padding: '0px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    justifyContent: 'center',
});

export const CustomTableContainer = styled(TableContainer)({
    border: '1px solid var(--black)',
    borderRadius: '32px',
    maxHeight: '330px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    '@media (max-width: 600px)': {
        margin: '0px',
        maxHeight: 'unset',
        padding: '12px 0',
    },
});

export const CustomTableRow = styled(TableRow)({
    width: '100%',
    display: 'flex !important',
    justifyContent: 'unset !important'
});

export const CustomTableCell = styled(TableCell)({
    padding: '8px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    '@media (max-width: 600px)': {
        fontSize: '12px !important',
    },
});

export const CustomTableCellAddress = styled(TableCell)({
    padding: '8px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    alignItems: 'center !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    '@media (max-width: 600px)': {
        fontSize: '12px !important',
    },
});

export const CustomTableCellLeft = styled(TableCell)({
    padding: '8px 24px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    '@media (max-width: 600px)': {
        fontSize: '12px !important',
    },
});

export const CustomTableCellRight = styled(TableCell)({
    padding: '8px!important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-end !important',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    '@media (max-width: 600px)': {
        fontSize: '12px !important',
    },
});

export const CuttomButtonAdd = styled(Button)({
    color: 'var(--black) !important',
    padding: '0px !important',
    borderBottom: 'unset !important',
    display: 'flex !important',
    justifyContent: 'center',
    fontWeight: '600 !important',
    fontSize: '14px !important'
});

export const CustomTableViewContainer = styled(TableContainer)({
    width: 'auto !important',
    border: '1px solid var(--black)',
    borderRadius: '32px',
    maxHeight: '430px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    '@media (max-width: 600px)': {
        margin: '0px',
        maxHeight: 'unset',
        padding: '12px 0',
    },
});

export const CustomPagination = styled(Pagination)({
    margin: '0',
    alignSelf: 'flex-end',
    '& .MuiPaginationItem-root': {
        color: 'var(--black)',
        fontSize: '14px',
        fontWeight: 500
    },
    '& .MuiPaginationItem-page.Mui-selected': {
        backgroundColor: 'transparent',
        color: 'var(--green)',
        fontSize: '14px',
        fontWeight: 700
    },
});

export const BoxCustomerID = styled(Box)({
    backgroundImage: "linear-gradient(to left, #52E01A 0%, #20AD4E 100%)",
    padding: "6px 48px 6px 24px",
    borderRadius: "25px",
    position: 'relative',
    width: '200px',
    zIndex: 1,

    '@media (max-width: 600px)': {
        width: '150px',
        padding: "6px 48px 6px 12px",
    },
});

export const CustomTitle = styled(Typography)({
    color: "var(--black)",
    fontWeight: "600 !important",
    fontSize: '14px',
    '@media (max-width: 600px)': {
        fontSize: '12px !important'
    },
});

export const BoxValueCustomerID = styled(TextField)({
    border: '1px solid var(--black)',
    borderRadius: "25px",
    background: "var(--white)",
    opacity: '0.9',
    marginLeft: '-48px !important',
    zIndex: 2,
    "& .MuiInputBase-input": {
        padding: '8px 24px !important',
        fontSize: '14px',
        fontWeight: 500,
        '@media (max-width: 600px)': {
            padding: '6px 24px !important',
        },
    },
    "& .MuiOutlinedInput-root": {
        borderRadius: '25px',
        "&:hover": {
            borderColor: 'unset',
        },
    }
});

export const getSearchParams = (_name: string) => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    return params.get(_name);
};

export const deleteSearchParams = (_name: any) => {
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    _name.map((value: any) => params.delete(value));
    return params.toString();
};